import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import AvatarModal from 'components/AvatarModal';

import { getUserPhotoURL } from 'utils';

import { ModalContainer } from './UserSetup.styled';

const signupSources = [
  'Search engines (Google, Bing, etc.)',
  'Online Advertisement',
  'Social Media',
  'Recommended by a friend or colleague',
  'G2, Capterra, Trustpilot and other review platform',
  'Other',
];

const UserSetup = ({
  currentUser,
  updateProfile,
  showImageUploadSizeLimitError,
}) => {
  const [name, setName] = useState('');
  const [avatar, setAvatar] = useState('avatar-0');
  const [signupSource, setSignupSource] = useState('default');
  const [otherSource, setOtherSource] = useState('');
  const [showAvatars, setShowAvatars] = useState(false);

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (
      name &&
      name.length > 0 &&
      avatar.length > 0 &&
      (signupSource !== 'default' || signupSource !== 'Other')
    )
      updateProfile({
        uid: currentUser.uid,
        displayName: name,
        photoURL: avatar,
        signupSource: signupSource === 'Other' ? otherSource : signupSource,
      });
  };

  const toggleAvatarModal = () => {
    setShowAvatars((state) => !state);
  };

  const changeAvatar = (value) => {
    setAvatar((state) => (state !== value ? value : state));
  };

  const signupSourceChangeHandler = (e) => setSignupSource(e.target.value);

  useEffect(() => {
    setName(currentUser.displayName || '');
    setAvatar(currentUser.photoURL || 'avatar-0');
  }, [currentUser]);

  return (
    <>
      <ModalContainer className="absolute-inset">
        <div>
          <h2 className="center">
            You&apos;re
            <br />
            almost done
          </h2>
          <form className="users-form" onSubmit={submitHandler}>
            <div className="center">
              <img
                src={getUserPhotoURL(avatar)}
                alt="avatar"
                height="88px"
                width="88px"
              />
            </div>
            <Button type="button" styled grey fluid onClick={toggleAvatarModal}>
              Choose a different avatar
            </Button>
            <label htmlFor="displayName">
              Display Name
              <input
                type="text"
                name="displayName"
                id="displayName"
                value={name}
                onChange={nameChangeHandler}
                placeholder="Enter your name"
                required
              />
            </label>
            <label htmlFor="signupSource">
              How did you hear about ruttl?
              <select
                name="signupSource"
                id="signupSource"
                value={
                  !signupSources.includes(signupSource) &&
                  signupSource !== 'default'
                    ? 'Other'
                    : signupSource
                }
                onChange={signupSourceChangeHandler}>
                <option value="default" disabled>
                  Select...
                </option>
                {signupSources.map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
              {/* eslint-disable indent */}
              {(signupSource === 'Other' ||
                !signupSources.includes(signupSource)) &&
                signupSource !== 'default' && (
                  <input
                    type="text"
                    name="signupSourceOther"
                    id="signupSourceOther"
                    value={otherSource}
                    onChange={(e) => setOtherSource(e.target.value)}
                    placeholder="Enter source"
                    required
                  />
                )}
              {/* eslint-enable indent */}
            </label>
            <Button
              type="submit"
              fluid
              disabled={
                (name && name.length === 0) ||
                (avatar && avatar.length === 0) ||
                signupSource === 'default' ||
                (signupSource === 'Other' && otherSource.length === 0)
              }>
              Finish
            </Button>
          </form>
        </div>
      </ModalContainer>
      {showAvatars && (
        <AvatarModal
          toggleAvatarModal={toggleAvatarModal}
          onSubmit={toggleAvatarModal}
          currentAvatar={avatar}
          changeAvatar={changeAvatar}
          showImageUploadSizeLimitError={showImageUploadSizeLimitError}
        />
      )}
    </>
  );
};

UserSetup.propTypes = {
  currentUser: PropTypes.object.isRequired,
  updateProfile: PropTypes.func.isRequired,
  showImageUploadSizeLimitError: PropTypes.func.isRequired,
};

export default UserSetup;
